import { Locale, Domain } from '@/types'
import NoImg from '@/assets/no-img.jpg'
import { trainOnlyLihes } from './trainOnlyLihes'

export const DEFAULT_IMAGE_PATH = NoImg

export const localeToDomainMap: Record<Locale, Domain> = {
  'fr-FR': 'www.travelski.com',
  'en-GB': 'www.uk.travelski.com',
  'en-US': 'www.uk.travelski.com',
  'nl-NL': 'www.nl.travelski.com',
  'fr-FR-CSE': 'cse.travelski.com',
  // Add more mappings as needed
}

// Reverse the map using forEach
export const domainToLocaleMap = {} as Record<Domain, Locale>
Object.entries(localeToDomainMap).forEach(([locale, domain]) => {
  domainToLocaleMap[domain] = locale as Locale
})

export enum LocaleEnum {
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  FR_FR = 'fr-FR',
  FR_FR_CSE = 'fr-FR-CSE',
  NL_NL = 'nl-NL',
}

export enum RouteConfig {
  LOGIN = 'login',
  CONFIRMED = 'confirmed',
  QUOTE = 'quote',
  PROFILE = 'profile',
  // Add more mappings as needed
}

export enum DomainEnum {
  FR = 'www.travelski.com',
  FR_CSE = 'cse.travelski.com',
  EN = 'www.uk.travelski.com',
  NL = 'www.nl.travelski.com',
  LOCAL = 'localhost' // For test proposes
}

export enum PrestType {
  Accomodation = 1,
  Fees = 3,
  Participant = 4,
  Insurance = 6,
}

export enum PackageEnum {
  PFTT = 'PFTT',
  PFPCS = 'PFPCS',
  PFCS = 'PFCS',
  PFP = 'PFP',
  PF = 'PF',
  PFF = 'PFF',
  PFPF = 'PFPF',
  HS = 'HS',
  /** Flight + Stay (no skipass) */
  HF = 'HF',
  /** Train + transfer + stay (no skipass) */
  HTT = 'HTT',
  /** Train + transfer + stay, FR market */
  HTTF = 'HTTF',
  PFTTF = 'PFTTF',
  PFPTTF = 'PFPTTF',
  /** NL variant of PFTT */
  PFTTNL = 'PFTTNL',
  /** NL variant of PFPTTF */
  PFPTTNL = 'PFPTTNL',
  /** UK TNE (night train) variant of PFTTF */
  PFTTUK = 'PFTTUK',
  /** UK TNE (night train) variant of PFPTTF */
  PFPTTUK = 'PFPTTUK',
}

export enum ServiceType {
  ADDITIONAL = 'additionalService',
  ACCOMMODATION = 'accommodationService',
}

export enum BookingStatus {
  Billed = 7,
  Cancellation = 104,
  Cancelled = 5,
  CancelledAfterBilling = 6,
  CancelledExpiredOption = 15,
  CancelledOnWeb = 107,
  PendingConfirmation = 106,
  CustomerPresent = 22,
  ClosedNoInvoice = 109,
  CancelledConsumption = 28,
  StockUnlocking = 25,
  Quote = 10,
  AgencyQuotes = 110,
  InService = 26,
  BilledPMS = 20,
  GoShow = 27,
  OutOfService = 21,
  Registration = 19,
  RegistrationAlt = 101,
  WaitingList = 102,
  OwnerOccupation = 11,
  Option = 3,
  AbandonedCart = 111,
  CartInProgress = 113,
  SupplierProblem = 108,
  SystemPayProblem = 112,
  MultiFilePayment = 29,
  Reservation = 2,
  ConvoyReservation = 23,
  VirtualStockReservation = 115,
  Settled = 105,
  StockLocking = 24,
}

export enum Channel {
  TravelskiCom = 2,
  TravelskiCoUk = 71,
  TravelskiNl = 72,
  TravelskiCse = 98,
  Yoonly = 80,
  MMVTrain = 102,
  TravelskiCseCosog = 103,
  SkiSchools = 104,
  AirBNB = 97,
  VRBO = 85,
  CarrefourVoyages = 13,
  Expedia = 78,
  BookingCom = 62,
  Carrefour = 92,
  CGOS = 47,
  Locasun = 86,
  LocatourCelineaires = 58,
  Wiismile = 70,
  LocatourSnotour = 36,
  GroupesExternes = 81,
  DJAY = 54,
  Touloisirs = 91,
  LastminutesCom = 6,
  Meyclub = 60,
  ClubEmployes = 100,
  ShowroomPriveCom = 51,
  CDiscountVoyages = 27,
  Defaut = 68,
}

/**
 * Export trainOnlyLihes for use across the application
 * This is the single source of truth for Travelski Express liheIds
 */
export { trainOnlyLihes } from './trainOnlyLihes'

/**
 * Helper function to check if a booking belongs to Travelski Express
 * @param liheId - The liheId of the booking
 * @param liheName - Optional liheName of the booking
 * @param packageCode - Optional packageCode of the booking
 * @returns true if the booking belongs to Travelski Express (either liheId is in trainOnlyLihes array OR liheName contains "Travelski Night Express" OR packageCode is "TNE" or "WTNE"), false otherwise
 */
export const isTravelskiExpress = (liheId: number, liheName?: string, packageCode?: string): boolean => {
  // Check if liheId is in the trainOnlyLihes array
  if (trainOnlyLihes.includes(liheId)) {
    return true
  }
  // Check if liheName contains "Travelski Night Express"
  if (liheName && liheName.includes('Travelski Night Express')) {
    return true
  }
  // Check if packageCode is "TNE" or "WTNE"
  if (packageCode === 'TNE' || packageCode === 'WTNE') {
    return true
  }
  return false
}